import { render, staticRenderFns } from "./IntegratorMovementsTable.vue?vue&type=template&id=40c2dfcb&"
import script from "./IntegratorMovementsTable.vue?vue&type=script&lang=js&"
export * from "./IntegratorMovementsTable.vue?vue&type=script&lang=js&"
import style0 from "./IntegratorMovementsTable.vue?vue&type=style&index=0&id=40c2dfcb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports